import React from 'react';
import { Accordion } from '../ui/Accordion';
export function FAQSection() {
  const faqs = [{
    question: '¿Realmente funciona en 15 minutos?',
    answer: 'Sí, porque el sistema elimina las tareas innecesarias y se enfoca solo en lo que el ojo ve. No estás limpiando la casa, estás preparando el escenario.'
  }, {
    question: '¿Qué pasa con el desorden que escondo?',
    answer: "El Blueprint incluye un plan de 'Cierre' para que gestiones esa caja al día siguiente con calma, sin la presión de una visita inminente."
  }, {
    question: '¿Necesito productos caros?',
    answer: 'No, solo un paño de microfibra, agua y un limpiador básico. La magia está en la técnica, no en los químicos.'
  }, {
    question: '¿Es un libro largo?',
    answer: 'No. Es una guía de acción directa diseñada para ser leída y aplicada de inmediato. Cero relleno, 100% tácticas.'
  }];
  return <section className="py-24 bg-stone-50" data-id="element-31">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-900 mb-12" data-id="element-33">
          Preguntas Frecuentes
        </h2>
        <Accordion items={faqs} data-id="element-34" />
      </div>
    </section>;
}